import * as AT from '@/constants/ActionTypes.js';

const initialState = {
  isGhostLogin: false,
};

const ghostLogin = (state = initialState, action) => {
  switch (action.type) {
    case AT.LOGIN_VIA_GHOST_LOGIN_SUCCESS:
      return {
        isGhostLogin: true,
      };
    default:
      return state;
  }
};

export default ghostLogin;
